import { applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';
import { IState } from '../../models/states';
import actionTypes from '../../utilities/actionTypes';
import epicMiddleware, { rootEpic } from './../epics/index';
import agentReducer, { initialAgentState } from './agentReducer';
import assetReducer, { initialAssetState } from './assetReducer';
import feedReducer, { initialFeedState } from './feedReducer';
import filterReducer, { initialFilterState } from './filterReducer';
import playlistReducer, { initialPlaylistState } from './playlistReducer';
import playoutReducer, { initialPlayoutState } from './playoutReducer';
import screenReducer, { initialScreenState } from './screenReducer';
import snackbarReducer, { initialSnackbarState } from './snackbarReducer';
import userReducer, { initialUserState } from './userReducer';
const middleWares: any = [];
// enable logger only in the development mode
if (process.env.NODE_ENV === `development`) {
  // middleWares.push(logger);
}

export const reducer = {
  assets: assetReducer,
  filters: filterReducer,
  user: userReducer,
  screens: screenReducer,
  feeds: feedReducer,
  agents: agentReducer,
  snackbar: snackbarReducer,
  playlists: playlistReducer,
  playouts: playoutReducer
};
// combining all the reducers <IAppState>
const appReducer = combineReducers(reducer);
export const initialState: IState = {
  assets: initialAssetState,
  feeds: initialFeedState,
  screens: initialScreenState,
  user: initialUserState,
  filters: initialFilterState,
  agents: initialAgentState,
  snackbar: initialSnackbarState,
  playlists: initialPlaylistState,
  playouts: initialPlayoutState
};
const rootReducer = (state: IState, action: any) => {
  if (action.type === actionTypes.AUTH_LOGOUT) {
    state = initialState as IState;
  }
  return appReducer(state as IState, action);
};
middleWares.push(epicMiddleware);
const composeEnhancers = composeWithDevTools({});
const store = createStore(
  rootReducer,
  initialState,
  composeEnhancers(applyMiddleware(...middleWares))
);
epicMiddleware.run(rootEpic);

export default store;
